// Клиент для `/api/public/clusters` — каталог площадок (кустов) публичного
// юзера. Средний уровень онтологии Field→Cluster→Well→Wellbore.
// Тонкая обёртка над generic `crudClient` (см. crudClient.ts).
// Типы — единый источник правды: ts-rs-генерация из
// `crates/backend/web_api_types/src/cluster.rs` (alias @webtypes, см.
// vite.config.ts / tsconfig.app.json). Регенерация — `cargo test -p web_api_types`.
//
// 🔑 Чем куст отличается от месторождения на этом уровне: у него есть ЯКОРЬ —
// центр площадки (OSDU `WellSiteStructure.SpatialLocation`). Якорь едет ЦЕЛИКОМ
// одним `AnchorDto` (пара в датуме либо метры в сетке), а не набором независимых
// колонок. Сетка (`crs`) — рядом с якорем, только у метров. Датумы и сетки —
// общий реестр `@webtypes/pointRegistry`, своего словаря здесь нет.

import type { ClusterDto } from '@webtypes/ClusterDto'
import type { CreateClusterBody } from '@webtypes/CreateClusterBody'
import type { UpdateClusterBody } from '@webtypes/UpdateClusterBody'
import type { AnchorDto } from '@webtypes/AnchorDto'
import { crudClient } from './crudClient'

export type { ClusterDto, CreateClusterBody, UpdateClusterBody, AnchorDto }
// 409 = площадка используется скважинами (FK ON DELETE RESTRICT); страница
// ловит его `instanceof InUseError`.
export { InUseError } from './crudClient'

const client = crudClient<ClusterDto, CreateClusterBody, UpdateClusterBody>(
  '/api/public/clusters',
  'Площадка используется в скважинах — удалить нельзя',
)

export const listClusters = client.list
export const createCluster = client.create
export const updateCluster = client.update
export const deleteCluster = client.remove
